import { render, staticRenderFns } from "./PurchasedAlbums.vue?vue&type=template&id=542ae19a&scoped=true"
import script from "./PurchasedAlbums.vue?vue&type=script&lang=js"
export * from "./PurchasedAlbums.vue?vue&type=script&lang=js"
import style0 from "./PurchasedAlbums.vue?vue&type=style&index=0&id=542ae19a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542ae19a",
  null
  
)

export default component.exports